export default __webpack_public_path__ + "static/media/road-D-photo.88b7f60c.svg";